import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Ta bort handlingslista", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "shopping-list-name",
  class: "col-sm-2 col-form-label fw-bold"
}, "Namn:", -1)
const _hoisted_5 = { class: "col-sm-10" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "table table-striped table-hover" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Vara"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Mängd"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Kommentar till butiken"),
      /*#__PURE__*/_createElementVNode("span", { class: "d-block d-md-none" }, "Kommentar")
    ])
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, "Listan saknar rader...", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
      class: "btn btn-link"
    }, " ← Tillbaka "),
    _hoisted_1,
    (_ctx.shoppingList)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                type: "text",
                readonly: "",
                class: "form-control-plaintext",
                id: "shopping-list-name",
                value: _ctx.shoppingList.name
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteShoppingList(_ctx.shoppingList)))
            }, " Ja, ta bort handlingslistan ")
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: { name: 'home' },
              type: "button",
              class: "btn btn-secondary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Nej, avbryt ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_9, [
      _hoisted_10,
      (_ctx.shoppingList)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
            (_ctx.shoppingList.rows.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingList.rows, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.id
              }, [
                _createElementVNode("td", null, _toDisplayString(row.text), 1),
                _createElementVNode("td", null, _toDisplayString(row.amount), 1),
                _createElementVNode("td", null, _toDisplayString(row.comment), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}